/**
 * Name of Background Shape
 */
export var BACKGROUND_SHAPE = 'element-background';
//# sourceMappingURL=constant.js.map